<template lang="jade" :title="title">
  section#landing-page(transition="home")
    #home
      h1 {{title}}
      p.home-copy {{copy}}
      a.home-link(v-link="{ path: '/targets' }") DISCOVER HDR
    #home-bg(v-bind:style="{ backgroundImage: 'url(' + background + ')' }")
</template>

<script>
  export default {
    data () {
      return {
        headline: "home",
        background: "https://s3-us-west-1.amazonaws.com/db13/1440/tech-head.jpg",
        copy: "We believe creativity is born of freedom. We believe that entertainment belongs to the many, not to the few. At Technicolor we fight for an open content future. Because without consensus, no one wins."
      }
    }
  }
  // initial - load
  setTimeout(function() {
    $('#landing-page').addClass('fade-in-slow');
  }, 300);

</script>

<style lang="sass?indentedSyntax" scoped>
  
  @import "../_sass/utilities/_utilities.sass"

  section#landing-page
    position: fixed
    top: 0
    left: 0
    z-index: 12
    opacity: 0

  #home-bg
    @extend %full-bg
    z-index: 10

  #home
    z-index: 11
    background-color: rgba(0,0,0,.35)

  #home,
  #home-bg
    @extend %aligner
    flex-flow: column
    position: absolute
    top: 0
    left: 0
    height: $container-height
    width: 100vw
    top: $container-pos
    
    a
      @extend %smooth
      @extend %white-border
      color: $white
      padding: 1rem 1.5rem
      margin-top: 3rem
      letter-spacing: 3px

      &:hover
        background-color: rgba(0,0,0,.35)
        border-color: $lime
        color: $lime
    p
      @extend %text-shadow
      max-width: 64rem
      font-size: 4rem

</style>


/** WEBPACK FOOTER **
 ** Home.vue?71d284c2
 **/